// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import axios from 'axios';

// const ChangePassword = () => {
//   const [oldPassword, setOldPassword] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [showOldPassword, setShowOldPassword] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const navigate = useNavigate();

//   const authData = localStorage.getItem("auth");
//   const authObject = JSON.parse(authData);
//   const token = authObject?.accessToken;

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (password === confirmPassword) {
//       try {
//         const response = await axios.post(
//           `${API_BASE}/user/changePassword`,
//           {
//             oldPassword,
//             newPassword: password,
//             confirmPassword: password
//           },
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         if (response.status === 200) {
//           setSuccess('Password changed successfully!');
//           navigate('/profile');  // Delay for user feedback
//         }

//       } catch (err) {
//         setError('Failed to change password. Please try again.');
//       }
//     } else {
//       setError('Passwords do not match');
//     }
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//   <div
//       className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
//       style={{
//         backgroundImage:
//           "url('https://static.vecteezy.com/system/resources/thumbnails/001/882/531/small_2x/dark-blue-technology-background-free-vector.jpg')",
//       }}
//     >
//       <div className="max-w-md w-full bg-white bg-opacity-95 p-5 rounded-md shadow-md">
//         <h2 className="text-center text-2xl mb-6 text-gray-800">Change Password</h2>
//         <form onSubmit={handleSubmit}>
//           {/* Old Password */}
//           <div className="mb-4 relative">
//             <label className="block text-gray-700">Old Password</label>
//             <input
//               type={showOldPassword ? 'text' : 'password'}
//               value={oldPassword}
//               onChange={(e) => setOldPassword(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//             <button
//               type="button"
//               onClick={() => setShowOldPassword(!showOldPassword)}
//               className="absolute inset-y-0 right-0 pr-3 pt-5 flex items-center text-sm leading-5"
//             >
//               {showOldPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>

//           {/* New Password */}
//           <div className="mb-4 relative">
//             <label className="block text-gray-700">New Password</label>
//             <input
//               type={showPassword ? 'text' : 'password'}
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword(!showPassword)}
//               className="absolute inset-y-0 right-0 pr-3 pt-5 flex items-center text-sm leading-5"
//             >
//               {showPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>

//           {/* Confirm Password */}
//           <div className="mb-4 relative">
//             <label className="block text-gray-700">Confirm Password</label>
//             <input
//               type={showConfirmPassword ? 'text' : 'password'}
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//             <button
//               type="button"
//               onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//               className="absolute inset-y-0 right-0 pr-3 pt-5 flex items-center text-sm leading-5"
//             >
//               {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>

//           {/* Messages */}
//           {error && <p className="text-red-500 text-center mb-4">{error}</p>}
//           {success && <p className="text-green-500 text-center mb-4">{success}</p>}

//           {/* Submit Button */}
//           <button
//             type="submit"
//             className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//           >
//             Save Password
//           </button>
//         </form>

//         {/* Links */}
//         <div className="text-center mt-4">
//           <p className="text-gray-700">
//             <Link to="/forgetpassword">
//               <button className="text-red-500 hover:underline">
//                 Go to Forget Password
//               </button>
//             </Link>
//           </p>
//           <p className="text-gray-700 mt-2">
//             <Link to="/login">
//               <button className="text-red-500 hover:underline">
//                 Go back to Login
//               </button>
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ChangePassword;
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { message } from 'antd'; // Using Antd message for notifications

// Global constant
const API_BASE = process.env.REACT_APP_API_BASE;

// ------------------- Reusable Input Field (Copied from UpdateProfile/Login) -------------------

const InputField = ({ label, name, type = "text", value, onChange, disabled, placeholder }) => (
  <div>
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
      placeholder={placeholder}
      required
    />
  </div>
);

// ------------------- Reusable Password Icons (Copied from Login.jsx) -------------------

const EyeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
    <path fillRule="evenodd" d="M1.323 11.487L.5 12l.823.513 9.875 6.172a3 3 0 002.606 0l9.875-6.172-.823-.513-9.875-6.172a3 3 0 00-2.606 0l-9.875 6.172zM12 9a3 3 0 100 6 3 3 0 000-6z" clipRule="evenodd" />
  </svg>
);

const EyeSlashIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
    <path d="M12.001 5.75c3.555 0 6.843 1.554 9.123 4.144a.75.75 0 010 1.109C18.844 14.717 15.555 16.272 12 16.272c-1.396 0-2.731-.296-3.955-.838l3.184-3.184A3 3 0 0012 12c.002-.27-.053-.53-.146-.777l-.613-.613 2.502-2.502a12.872 12.872 0 013.882 1.696.75.75 0 00.999-1.127A14.288 14.288 0 0012.001 4.25a.75.75 0 000 1.5z" />
    <path d="M22.84 21.08a.75.75 0 001.077 1.058l-1.077-1.058zM17.072 16.634l-3.235-3.235A3.01 3.01 0 0012 11.75a3.01 3.01 0 00-3.003 3.022.75.75 0 001.5.023A1.5 1.5 0 0112 13.25c.484 0 .937.198 1.258.534l3.235 3.235a13.31 13.31 0 01-3.418 1.545.75.75 0 10-.361 1.458 14.815 14.815 0 004.288-1.895l1.621 1.621a.75.75 0 001.06-.02z" />
    <path fillRule="evenodd" d="M18.91 19.82a.75.75 0 00-.001-.001L4.17 5.17A.75.75 0 105.17 4.17L19.83 18.83a.75.75 0 00.001 1.07zm-11.896-.705l-4.577-4.578a.75.75 0 00-.001-.001L1.25 12l.718-.448 4.578 4.578a.75.75 0 00.705.001z" clipRule="evenodd" />
  </svg>
);


// ------------------- Reusable Password Field Component -------------------

const PasswordFieldComponent = ({ label, value, onChange, showPassword, togglePasswordVisibility, disabled }) => (
    <div className="relative">
        <label className="block text-gray-700 text-sm mb-1">{label}</label>
        <input
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 pr-10 disabled:bg-gray-100"
            required
        />
        <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-0 mt-8 text-gray-600 hover:text-green-700 disabled:opacity-50"
            disabled={disabled}
        >
            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
        </button>
    </div>
);


const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  // Separate visibility states for each field
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const [loadingSubmit, setLoadingSubmit] = useState(false); // New loading state for submission
  
  const navigate = useNavigate();

  // --- Auth Data Retrieval ---
  let authObject = null;
  try {
    const authData = localStorage.getItem("auth");
    if (authData) {
      authObject = JSON.parse(authData);
    }
  } catch (error) {
    console.error("Error parsing auth data from localStorage:", error);
  }
  const token = authObject?.accessToken;

  // Check if token exists and disable form if not
  const isFormDisabled = loadingSubmit || !token;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!token) {
        message.error("Authentication token missing. Please log in.");
        return;
    }

    if (password !== confirmPassword) {
      message.error('New Password and Confirm Password do not match.');
      return;
    }

    setLoadingSubmit(true);

    try {
      const response = await axios.post(
        `${API_BASE}/user/changePassword`,
        {
          oldPassword,
          newPassword: password,
          // Sending confirmPassword here is redundant based on the API structure, 
          // but if the API expects it, it should be the new password value.
          confirmPassword: password 
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        message.success('Password changed successfully! You will be redirected to your profile.');
        // Clear fields on success
        setOldPassword('');
        setPassword('');
        setConfirmPassword('');
        
        // Wait briefly for the message to show, then navigate
        setTimeout(() => {
            navigate('/profile'); 
        }, 1500);
        
      } else {
         message.error(response.data.message || 'Failed to change password. Please check your current password.');
      }
    } catch (err) {
      console.error("Change Password Error:", err);
      // Display a more specific error message from the response if available
      const errorMessage = err.response?.data?.message || 'Failed to change password. Please check your old password.';
      message.error(errorMessage);
    } finally {
        setLoadingSubmit(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          // MF Blind style background
          "url('https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
      }}
    >
      <div className="max-w-md w-full bg-white bg-opacity-95 p-8 rounded-lg shadow-2xl border border-gray-200">
        
        {/* MF Blind-style Header */}
        <div className="mb-6 border-b pb-4 text-center">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <h2 className="text-2xl mt-2 text-gray-800">Change Password</h2>
        </div>

        {/* Auth check warning */}
        {!token && (
            <p className="text-center text-red-500 mb-4">You must be logged in to change your password.</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          
          {/* Old Password */}
          <PasswordFieldComponent
            label="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            showPassword={showOldPassword}
            togglePasswordVisibility={() => setShowOldPassword(!showOldPassword)}
            disabled={isFormDisabled}
          />

          {/* New Password */}
          <PasswordFieldComponent
            label="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            showPassword={showPassword}
            togglePasswordVisibility={() => setShowPassword(!showPassword)}
            disabled={isFormDisabled}
          />

          {/* Confirm Password */}
          <PasswordFieldComponent
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            showPassword={showConfirmPassword}
            togglePasswordVisibility={() => setShowConfirmPassword(!showConfirmPassword)}
            disabled={isFormDisabled}
          />

          {/* Submit Button (MF Blind Green Style) */}
          <button
            type="submit"
            className="w-full py-3 mt-6 bg-green-700 text-white rounded-md font-semibold hover:bg-green-800 transition duration-150 shadow-md disabled:opacity-50"
            disabled={isFormDisabled}
          >
            {loadingSubmit ? 'Saving...' : 'Save Password'}
          </button>
        </form>

        {/* Links (MF Blind Green Style) */}
        <div className="text-center mt-6 text-sm flex justify-between">
          <Link 
            to="/forgetpassword"
            className={`text-green-700 hover:text-green-900 font-medium ${isFormDisabled ? 'pointer-events-none opacity-60' : ''}`}
          >
            <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                Forget Password?
            </span>
          </Link>
          <Link 
            to="/profile"
            className={`text-green-700 hover:text-green-900 font-medium ${isFormDisabled ? 'pointer-events-none opacity-60' : ''}`}
          >
            <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                Back to Profile
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;